// @ts-expect-error - Automatic, Please fix when editing this file
const selectHasPartnerReferrer = (state) => !!state?.referrer?.hasPartnerReferrer;

export default selectHasPartnerReferrer;
